import { GridColDef } from "@mui/x-data-grid";
import CustomDataGrid from "../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Person4 } from "@mui/icons-material";
import { CLIENTS_ENDPOINT } from "../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../contexts/auth";
import GridAddressCell from "../../components/ui/gridAddressCell/gridAddressCell.component";
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
  equalsStringFilterOperators,
} from "../../components/ui/customDataGrid/filterOperators";

export default function ClientList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewClients = useHasPermission("settlement.view_client");

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      filterOperators: equalsNumberFilterOperators(),
    },
    {
      field: "name",
      headerName: t("Name"),
      filterOperators: containsStringFilterOperators(),
      renderCell: (params) => params.row.short_name || params.row.name,
    },
    {
      field: "address",
      headerName: t("Address"),
      editable: false,
      sortable: false,
      filterable: false,
      valueGetter: (value, row) => {
        const address = row.address;
        return `${address.street}, ${address.zip_code} ${address.city}`;
      },
      renderCell: (params) => {
        const address = params.row.address;
        if (!address) {
          return null;
        }

        return <GridAddressCell address={address} />;
      },
    },
    {
      field: "nip",
      headerName: "NIP",
      filterOperators: equalsStringFilterOperators(),
    },
    {
      field: "regon",
      headerName: "REGON",
      filterOperators: equalsStringFilterOperators(),
    },
    {
      field: "krs",
      headerName: "KRS",
      filterOperators: equalsStringFilterOperators(),
    },
    {
      field: "pesel",
      headerName: "PESEL",
      filterOperators: equalsStringFilterOperators(),
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/clients/${id}`);
  };

  if (!canViewClients) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Person4 />}
      title={t("Clients list")}
      url={CLIENTS_ENDPOINT}
      gridSettingsKey="CLIENTS"
      columns={columns}
      refreshEventName="clientAdded"
      onRowClick={handleRowClick}
    />
  );
}
